/* eslint-disable react/no-unstable-nested-components */
import { useMemo } from 'react';
import { AnimatedGridRows, AnimatedGridColumns } from '@visx/react-spring';
import BaseGrid from "./BaseGrid.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedGrid(_ref) {
  let {
    animationTrajectory,
    ...props
  } = _ref;
  const RowsComponent = useMemo(() => function RowsFC(rowProps) {
    return /*#__PURE__*/_jsx(AnimatedGridRows, {
      ...rowProps,
      animationTrajectory: animationTrajectory
    });
  }, [animationTrajectory]);
  const ColumnsComponent = useMemo(() => function ColumnsFC(rowProps) {
    return /*#__PURE__*/_jsx(AnimatedGridColumns, {
      ...rowProps,
      animationTrajectory: animationTrajectory
    });
  }, [animationTrajectory]);
  return /*#__PURE__*/_jsx(BaseGrid, {
    GridRowsComponent: RowsComponent,
    GridColumnsComponent: ColumnsComponent,
    ...props
  });
}